<ng-template [ngIf]="!!details?.Applicable">
    <div *ngIf="config.showTitle" class="row push-down">
        <div class="col-sm-12">
            <strong>{{title}}:</strong>
        </div>
    </div>
    <div class="row" [ngClass]="{ 
        'bold-labels': config.shouldBoldLabels, 
        'bold-values': config.shouldBoldValues 
    }">
        <div class="col-sm-12">
            <span class="summary-label">Hours: </span>
            <span class="summary-value">{{details.Hours}}</span>
        </div>
        <div *ngIf="!isComplianceItem" class="col-sm-12">
            <span class="summary-label">Event: </span>
            <span class="summary-value">{{details.EventName}}</span>
        </div>
        <div *ngIf="!isComplianceItem" class="col-sm-12">
            <span class="summary-label">Start: </span>
            <span class="summary-value">{{ details.EventStartDate | dateExtended: config.dateFormat }}</span>
        </div>
        <div *ngIf="!isComplianceItem" class="col-sm-12">
            <span class="summary-label">End: </span>
            <span class="summary-value">{{ details.EventEndDate | dateExtended: config.dateFormat}}</span>
        </div>
    </div>
</ng-template>

